var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousingDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.4004V16.4004C7.68629 16.4004 5 19.0867 5 22.4004H3C3 17.9821 6.58172 14.4004 11 14.4004ZM11 13.4004C7.685 13.4004 5 10.7154 5 7.40039C5 4.08539 7.685 1.40039 11 1.40039C14.315 1.40039 17 4.08539 17 7.40039C17 10.7154 14.315 13.4004 11 13.4004ZM11 11.4004C13.21 11.4004 15 9.61039 15 7.40039C15 5.19039 13.21 3.40039 11 3.40039C8.79 3.40039 7 5.19039 7 7.40039C7 9.61039 8.79 11.4004 11 11.4004ZM17 21.9004L14.0611 23.4455L14.6224 20.1729L12.2447 17.8553L15.5305 17.3779L17 14.4004L18.4695 17.3779L21.7553 17.8553L19.3776 20.1729L19.9389 23.4455L17 21.9004Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingDatabase);
export default __webpack_public_path__ + "static/media/housing-database.fe3591f75b63f0dc6f4ae6f2634a8153.svg";
export { ForwardRef as ReactComponent };